const safeOaiq = (...argumentsList) => {
  if (typeof window === "undefined" || typeof window.oaiq !== "function") {
    return;
  }

  window.oaiq(...argumentsList);
};

const sendLeadCreatedTag = () => {
  safeOaiq("measure", "lead_created", { type: "customer_action" });
};

const sendPropostaGeradaTag = () => {
  safeOaiq(
    "measure",
    "custom",
    { type: "custom" },
    { custom_event_name: "proposta_gerada" },
  );
};

const sendOrderCreatedTag = () => {
  safeOaiq("measure", "order_created", { type: "contents" });
};

export { sendLeadCreatedTag, sendPropostaGeradaTag, sendOrderCreatedTag };